export enum PartnerRouteNames {
    PARTNER = "Partner",
    OVERVIEW = "OverviewDashboard",
    TRANSACTIONS = "Transactions",
    ORDER_PAYMENTS = "OrderPayments",
    SUPPORT = "Support",
    SETTINGS = "Settings",
    ACCOUNT_INFORMATION = "AccountInformation",
}

export enum AuthRouteNames {
    LOGIN = "LoginEsenda",
    UNAUTHORISED_ACCESS = "UnauthorisedAccess",
    NOT_FOUND = "404",
}
